<template>
  <div class="portal">
    <decsaDashboard v-if="auth_level === 1" />
    <caDashboard v-else-if="auth_level === 2" />
    <agencyDashboard v-else-if="auth_level === 3" />
    <carrierDashboard v-else-if="auth_level === 4" />
    <terminalDashboard v-else-if="auth_level === 5" />
    <consigneeDashboard v-else-if="auth_level === 6" />
  </div>
</template>

<script>
import decsaDashboard from "@/components/portal/decsa/Dashboard";
import caDashboard from "@/pages/NotFoundPage";
import agencyDashboard from "@/pages/NotFoundPage";
import carrierDashboard from "@/components/portal/carrier/Dashboard";
import terminalDashboard from "@/pages/NotFoundPage";
import consigneeDashboard from "@/components/portal/customer/Dashboard";

export default {
  components: {
    caDashboard,
    agencyDashboard,
    carrierDashboard,
    terminalDashboard,
    consigneeDashboard,
    decsaDashboard,
  },
  computed: {
    auth_level() {
      return this.$store.state.current_profile.type;
    }
  },
};
</script>
